module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__view-system--section"
  }, [_c('div', {
    staticClass: "system-builder__main-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "system-builder__view-system--main-container"
  }, [_c('div', {
    staticClass: "system-builder__view-system--complete-system-container"
  }, [_c('div', {
    staticClass: "system-builder__view-system--system-container"
  }, [_c('div', {
    staticClass: "system-builder__view-system--edit-nav"
  }, [_c('span', [_vm._v("Your System")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.printSystem
    }
  }, [_vm._v("PRINT")])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__view-system--system-complete"
  }, [(_vm.sharedState.selectedSystem.images) ? _c('div', {
    staticClass: "system-builder__view-system--system-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.sharedState.selectedSystem.images.image.url,
      "alt": _vm.sharedState.selectedSystem.images.image.alt
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "system-builder__view-system--system-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.systemString))]), _vm._v(" "), _c('ul', [(_vm.sharedState.vehicleObject.vehicleSpecificId !== '' && _vm.sharedState.security === false) ? _c('li', [_vm._v("T-harness: " + _vm._s(_vm.sharedState.vehicleObject.vehicleSpecificId))]) : _c('li', [_vm._v(_vm._s(_vm.sharedState.selectedSystem.model_number))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.sharedState.selectedMake) + " / " + _vm._s(_vm.sharedState.selectedModel) + " / " + _vm._s(_vm.sharedState.selectedYearValue) + "\n                ")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.compatibilityMessage))])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.sharedState.selectedSystem.description)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__view-system--addon-container"
  }, [_c('div', {
    staticClass: "system-builder__view-system--remote-container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "system-builder__remotes--item"
  }, [(_vm.sharedState.selectedRemote.images) ? _c('div', {
    staticClass: "system-builder__remotes--item-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.sharedState.selectedRemote.images.image.url,
      "alt": _vm.sharedState.selectedRemote.images.image.alt
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "system-builder__remotes--item-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.sharedState.selectedRemote.post_title))]), _vm._v(" "), _c('ul', _vm._l((_vm.sharedState.selectedRemote.remote_features_text), function(feature, featureIndex) {
    return (featureIndex < 3) ? _c('li', {
      domProps: {
        "innerHTML": _vm._s(feature)
      }
    }) : _vm._e()
  }))])])]), _vm._v(" "), (_vm.sharedState.selectedUpgrades !== undefined && _vm.sharedState.selectedUpgrades.length > 0) ? _c('div', {
    staticClass: "system-builder__view-system--upgrades-container"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.sharedState.selectedUpgrades), function(upgrade) {
    return _c('div', {
      staticClass: "system-builder__upgrades--item"
    }, [_c('div', {
      staticClass: "system-builder__upgrades--item-image"
    }, [_c('img', {
      attrs: {
        "src": upgrade.images.image.url,
        "alt": upgrade.images.image.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "system-builder__upgrades--item-content"
    }, [_c('h4', [_vm._v(_vm._s(upgrade.post_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(upgrade.subtitle))])])])
  })], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__view-system--contact-container"
  }, [(_vm.sharedState.formPassedValidation === false) ? _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('contactInfo', {
    on: {
      "submitContactForm": _vm.checkFormValidation
    }
  })], 1) : (_vm.isCanadianPostCode) ? _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('canadianContact')], 1) : _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('dealerList')], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__main-container--header"
  }, [_c('h2', [_vm._v("Get a Quote from Your Local Dealer!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__view-system--edit-nav"
  }, [_c('span', [_vm._v("Your Remote")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__view-system--edit-nav"
  }, [_c('span', [_vm._v("Your Upgrades")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72117266","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/ViewSystem.vue
// module id = 425
// module chunks = 1